import api from "../../utils/Api";
import {
    UPDATE_DESTINATION_CODES_REQUEST,
    UPDATE_DESTINATION_CODES_SUCCESS,
    UPDATE_DESTINATION_CODES_ERROR,
} from "./UpdateDestinationCodesTypes";

export const updateDestinationCodesRequest = () => {
    return {
        type: UPDATE_DESTINATION_CODES_REQUEST,
    };
};

export const updateDestinationCodesSuccess = (updateDestinationCodes) => {
    return {
        type: UPDATE_DESTINATION_CODES_SUCCESS,
        payload: updateDestinationCodes,
    };
};

export const updateDestinationCodesFailure = (error) => {
    return {
        type: UPDATE_DESTINATION_CODES_ERROR,
        payload: error,
    };
};

export const updateDestinationCodes = () => {

    const headers = {
        'Content-Type': 'application/json',
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };

    return async (dispatch) => {
        dispatch(updateDestinationCodesRequest());
        try {
            const response = await api.post("destinationcode/download", null, {
                headers: headers,
            });
            const updateDestinationCodesData = response.data;
            dispatch(updateDestinationCodesSuccess(updateDestinationCodesData));
        } catch (error) {
            console.log("Redux error - ", error.response.data.message);
            const errorMsg = error.response.data.message;
            dispatch(updateDestinationCodesFailure(errorMsg));
        }
    };
};
